import { useEffect, useMemo, useState } from "react";

import { getProxifiedUrl } from "@/utils";

/**
 * Proxifies url
 * @param url - url to proxify
 * @param active - if set to false, hook will return original url
 * @returns url
 */
export const useProxifiedUrl = (
  url: string | null | undefined = "",
  active: boolean = true,
) => {
  const [proxifiedUrl, setProxifiedUrl] = useState<string | null>(null);
  const urlString = url || "";
  const src = useMemo(
    () => (active ? proxifiedUrl || urlString : urlString),
    [active, proxifiedUrl, urlString],
  );

  useEffect(() => {
    let mounted = true;

    if (!active || !urlString) {
      setProxifiedUrl(null);
      return;
    }

    if (proxifiedUrl) {
      return;
    }

    (async () => {
      const proxifiedUrl = await getProxifiedUrl(urlString);
      mounted && setProxifiedUrl(proxifiedUrl);
    })();

    return () => {
      mounted = false;
    };
  }, [active, proxifiedUrl, url, urlString]);

  return src;
};
